<template>
  <v-dialog v-model="dialog" persistent width="840">
    <!-- ACTIVATOR BUTTON -->
    <v-btn small slot="activator" color="primary" flat>
      <v-icon small class="pr-2">mdi-bank-transfer</v-icon>Bank To Bank Transfer
    </v-btn>

    <v-card>
      <v-card-title class="title font-weight-regular grey--text text--darken-2">
        <v-layout row wrap align-center>
          <v-icon class="pr-2">mdi-bank-transfer</v-icon>
          <span>Bank To Bank Transfer</span>
        </v-layout>
      </v-card-title>
      <v-card-text v-if="!transactionDone">
        <v-layout row wrap class="text-xs-center">
          <!-- FROM -->
          <v-flex xs5>
            <v-layout row wrap justify-center class="pl-4 pb-4">
              <v-flex xs12 class="text-xs-center">
                <span class="grey--text text--darken-1 font-weight-bold">From</span>
              </v-flex>
              <!-- FROM BANK ID -->
              <v-flex xs12>
                <v-autocomplete
                  dense
                  :items="bankInformationsPerSubsidiary"
                  :item-disabled="set_disabled_from"
                  item-value="id"
                  item-text="name"
                  background-color="white"
                  browser-autocomplete="noautocomplete"
                  label="From"
                  v-model="bankToBankTransaction.from.bank_information_id"
                >
                  <template slot="label">
                    <v-icon size="14" class="pr-1" color="#757575">mdi-bank-transfer-out</v-icon>From Account
                  </template>
                </v-autocomplete>
              </v-flex>
              <!-- FROM AMOUNT & CURRRENCY -->
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs7>
                    <v-text-field
                      type="number"
                      v-model="bankToBankTransaction.from.amount"
                      :prefix="
                        currencyIdFrom
                          ? getSymbolFromCode(getCodeFromId(currencyIdFrom))
                          : ''
                      "
                    >
                      <template slot="label">
                        <v-icon size="14" class="pr-1" color="#757575">mdi-cash</v-icon>Amount
                        <span class="caption font-weight-bold">(incl. bank charges)</span>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs5 class="pl-3">
                    <v-autocomplete
                      dense
                      :items="currencies"
                      item-value="id"
                      item-text="name"
                      disabled
                      background-color="white"
                      browser-autocomplete="noautocomplete"
                      label="Currency"
                      :value="currencyIdFrom"
                    >
                      <template slot="label">
                        {{
                        currencyIdFrom
                        ? getSymbolFromCode(getCodeFromId(currencyIdFrom)) +
                        " "
                        : ""
                        }}Currency
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>

              <!-- FROM BANK CHARGES -->
              <v-flex xs12>
                <v-text-field
                  :prefix="
                    currencyIdFrom
                      ? getSymbolFromCode(getCodeFromId(currencyIdFrom))
                      : ''
                  "
                  type="number"
                  v-model="bankToBankTransaction.from.charges_amount"
                >
                  <template slot="label">
                    <v-icon size="14" class="pr-1" color="#757575">mdi-cash</v-icon>Bank Charges
                  </template>
                </v-text-field>
              </v-flex>

              <!-- FROM REFERENCE -->
              <v-flex xs12>
                <v-text-field v-model="bankToBankTransaction.from.reference">
                  <template slot="label">
                    <v-icon size="14" class="pr-1" color="#757575">mdi-format-quote-close</v-icon>Reference
                  </template>
                </v-text-field>
              </v-flex>

              <!-- FROM BANK PAYMENT DATE -->
              <v-flex xs12>
                <v-menu
                  ref="menu"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :value="
                      bankToBankTransaction.from.payment_date
                        ? timeToDate(bankToBankTransaction.from.payment_date)
                        : null
                    "
                    label="Payment Date"
                    readonly
                  >
                    <template slot="label">
                      <v-icon size="14" class="pr-1" color="#757575">event</v-icon>Payment Date
                    </template>
                  </v-text-field>
                  <v-date-picker
                    v-model="bankToBankTransaction.from.payment_date"
                    no-title
                    scrollable
                    first-day-of-week="1"
                  />
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- MIDDLE ARROW ICON -->
          <v-flex xs2>
            <v-layout row wrap fill-height align-center>
              <v-flex xs12>
                <v-icon size="36" color="success">mdi-transfer-right</v-icon>
                <br />
                <v-label>
                  Exch. Rate:
                  <span class="font-weight-bold">x{{ exchangeRate }}</span>
                </v-label>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- TO -->
          <v-flex xs5>
            <v-layout row wrap justify-center class="pr-4 pb-4">
              <v-flex xs12 class="text-xs-center">
                <span class="grey--text text--darken-1 font-weight-bold">To</span>
              </v-flex>

              <!-- TO BANK ID -->
              <v-flex xs12>
                <v-autocomplete
                  dense
                  :items="bankInformationsPerSubsidiary"
                  item-value="id"
                  item-text="name"
                  background-color="white"
                  browser-autocomplete="noautocomplete"
                  label="To"
                  v-model="bankToBankTransaction.to.bank_information_id"
                  :item-disabled="set_disabled_to"
                >
                  <template slot="label">
                    <v-icon size="14" class="pr-1" color="#757575">mdi-bank-transfer-out</v-icon>To Account
                  </template>
                </v-autocomplete>
              </v-flex>

              <!-- TO AMOUNT && CURRENCY -->
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs7>
                    <v-text-field
                      :prefix="
                        currencyIdTo
                          ? getSymbolFromCode(getCodeFromId(currencyIdTo))
                          : ''
                      "
                      type="number"
                      v-model="bankToBankTransaction.to.amount"
                    >
                      <template slot="label">
                        <v-icon size="14" class="pr-1" color="#757575">mdi-cash</v-icon>Amount
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs5 class="pl-3">
                    <v-autocomplete
                      dense
                      :items="currencies"
                      item-value="id"
                      item-text="name"
                      disabled
                      background-color="white"
                      browser-autocomplete="noautocomplete"
                      label="Currency"
                      :value="currencyIdTo"
                    >
                      <template slot="label">
                        {{
                        currencyIdTo
                        ? getSymbolFromCode(getCodeFromId(currencyIdTo)) +
                        " "
                        : ""
                        }}Currency
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>

              <!-- TO BANK REFERENCE -->
              <v-flex xs12>
                <v-text-field v-model="bankToBankTransaction.to.reference">
                  <template slot="label">
                    <v-icon size="14" class="pr-1" color="#757575">mdi-format-quote-close</v-icon>Reference
                  </template>
                </v-text-field>
              </v-flex>

              <!-- TO BANK PAYMENT DATE -->
              <v-flex xs12>
                <v-menu
                  ref="menu"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :value="
                      bankToBankTransaction.to.payment_date
                        ? timeToDate(bankToBankTransaction.to.payment_date)
                        : null
                    "
                    label="Payment Date"
                    readonly
                  >
                    <template slot="label">
                      <v-icon size="14" class="pr-1" color="#757575">event</v-icon>Payment Date
                    </template>
                  </v-text-field>
                  <v-date-picker
                    v-model="bankToBankTransaction.to.payment_date"
                    no-title
                    scrollable
                    first-day-of-week="1"
                  />
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text v-else class="pa-5 text-xs-center">
        <v-icon color="success" size="74">mdi-bank-transfer</v-icon>
        <h3 class="title font-weight-light my-2">Transfer Done!</h3>
        <span class="caption grey--text">You can close this form</span>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="error" small flat @click="dialog = false">
          <v-icon small class="pr-2">close</v-icon>
          {{ transactionDone ? "Close" : "Cancel" }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-show="!transactionDone"
          color="success"
          class="white--text"
          small
          depressed
          :disabled="!canSave"
          @click="submitTransfer()"
        >
          <v-icon small class="pr-2">mdi-shield-check</v-icon>Confirm Bank
          Transfer
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- <json-viewer :value="bankInformationsPerSubsidiary" sort></json-viewer> -->
  </v-dialog>
</template>

<script>
import currency from "../../../mixins/currency.js";
import { mapGetters } from "vuex";
import date from "../../../mixins/date.js";
import TRANSFER_BANK_TRANSACTION from "../../../graphql/bank_transactions/transfer.gql";
import JsonViewer from "vue-json-viewer";
export default {
  name: "bankToBankTransferForm",
  mixins: [currency, date],
  components: { JsonViewer },
  data() {
    return {
      dialog: false,
      bankToBankTransaction: null,
      transactionDone: false,
    };
  },
  computed: {
    ...mapGetters("commonStore", [
      "currencies",
      "bankInformations",
      "subsidiaries",
      "getNameById",
    ]),
    bankInformationsPerSubsidiary() {
      // retrieve uinique subsidiary ids found in bankInformations
      var subsidiary_ids = [
        ...new Set(
          this.bankInformations.map((b) => {
            return b.subsidiary_id;
          })
        ),
      ];
      var retArr = [];

      subsidiary_ids.forEach((sid) => {
        retArr.push({
          header: this.subsidiaries.find((s) => {
            return s.subsidiary.id == sid;
          }).name,
        });
        this.bankInformations
          .filter((b) => {
            return b.subsidiary_id == sid;
          })
          .forEach((bi) => {
            retArr.push(bi);
          });

        //retArr.push(this.bankInformations.filter(b=> {return b.subsidiary_id == sid}));
      });

      return retArr;
    },
    currencyIdFrom() {
      if (this.bankToBankTransaction.from.bank_information_id)
        return this.bankInformations.find(
          (bi) => bi.id == this.bankToBankTransaction.from.bank_information_id
        ).currency_id;
      else return null;
    },
    currencyIdTo() {
      if (this.bankToBankTransaction.to.bank_information_id)
        return this.bankInformations.find(
          (bi) => bi.id == this.bankToBankTransaction.to.bank_information_id
        ).currency_id;
      else return null;
    },
    exchangeRate() {
      if (
        this.bankToBankTransaction.from.amount == 0 ||
        this.bankToBankTransaction.to.amount == 0
      )
        return "--";
      return (
        this.bankToBankTransaction.to.amount /
        this.bankToBankTransaction.from.amount
      ).toFixed(2);
    },
    canSave() {
      if (
        !this.bankToBankTransaction.from.bank_information_id ||
        !this.bankToBankTransaction.from.payment_date ||
        this.bankToBankTransaction.from.amount == 0 ||
        !this.bankToBankTransaction.from.reference ||
        !this.bankToBankTransaction.to.bank_information_id ||
        !this.bankToBankTransaction.to.payment_date ||
        this.bankToBankTransaction.to.amount == 0 ||
        !this.bankToBankTransaction.to.reference
      )
        return false;
      return true;
    },
  },
  methods: {
    set_disabled_from(item) {
      var item_is_disabled = false;

      //disable item if it's the same bank id
      if (item.id == this.bankToBankTransaction.to.bank_information_id)
        item_is_disabled = true;

      //disable item if it doesnt belong to the same subsidiary_id

      if (
        this.bankToBankTransaction.to.bank_information_id &&
        item.subsidiary_id !=
          this.bankInformations.find((bi) => {
            return bi.id == this.bankToBankTransaction.to.bank_information_id;
          }).subsidiary_id
      )
        item_is_disabled = true;

      return item_is_disabled;
    },
    set_disabled_to(item) {
      var item_is_disabled = false;

      //disable item if it's the same bank id
      if (item.id == this.bankToBankTransaction.from.bank_information_id)
        item_is_disabled = true;

      //disable item if it doesnt belong to the same subsidiary_id
      // if (
      //   this.bankToBankTransaction.from.bank_information_id &&
      //   item.subsidiary_id !=
      //     this.bankInformations.find((bi) => {
      //       return bi.id == this.bankToBankTransaction.from.bank_information_id;
      //     }).subsidiary_id
      // )
      //   item_is_disabled = true;
//
      return item_is_disabled;
    },
    resetForm() {
      this.transactionDone = false;
      this.bankToBankTransaction = {
        from: {
          bank_information_id: "",
          payment_date: new Date().toISOString().substr(0, 10),
          amount: 0,
          charges_amount: 0,
          reference: "",
        },
        to: {
          bank_information_id: "",
          payment_date: new Date().toISOString().substr(0, 10),
          amount: 0,
          reference: "",
        },
      };
    },
    submitTransfer() {
      this.bankToBankTransaction.from.amount =
        parseFloat(this.bankToBankTransaction.from.amount) || 0;
      this.bankToBankTransaction.from.charges_amount =
        parseFloat(this.bankToBankTransaction.from.charges_amount) || 0;
      this.bankToBankTransaction.to.amount =
        parseFloat(this.bankToBankTransaction.to.amount) || 0;
      this.sendMutation(
        "transfered",
        "money",
        TRANSFER_BANK_TRANSACTION,
        this.bankToBankTransaction
      ).then(() => {
        this.transactionDone = true;
      });
    },
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.resetForm();
      }
    },
  },
  created() {
    this.resetForm();
  },
};
</script>
